import { render, staticRenderFns } from "./toggleSidebar.vue?vue&type=template&id=079b5bfc&scoped=true"
import script from "./toggleSidebar.vue?vue&type=script&lang=js"
export * from "./toggleSidebar.vue?vue&type=script&lang=js"
import style0 from "./toggleSidebar.vue?vue&type=style&index=0&id=079b5bfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079b5bfc",
  null
  
)

export default component.exports